import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { DataUtilService } from 'src/app/_services/data-util.service';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AnalyticsService {

  headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
  options = { headers: this.headers }

  constructor(
    private http: HttpClient,
    private dataUtilService: DataUtilService
  ) { }
  getRegistrations() {
    return this.http.get<any[]>(`${environment.apiUrl}/analytic/getregistrations`).pipe(map(
      val => {
        if (this.dataUtilService.isGoodResponse(val)) {
          return this.dataUtilService.myData(val)
        }
      }
    ))
  }
  getEnrolments(){
    return this.http.get<any[]>(`${environment.apiUrl}/analytic/getenrolments`).pipe(map(
      val => {
        if (this.dataUtilService.isGoodResponse(val)) {
          return this.dataUtilService.myData(val)
        }
      }
    ))
  }

  getPayments(){
    return this.http.get<any[]>(`${environment.apiUrl}/analytic/getpayments`).pipe(map(
      val => {
        if (this.dataUtilService.isGoodResponse(val)) {
          return this.dataUtilService.myData(val)
        }
      }
    ))
  }


  getQuiz(){
    return this.http.get<any[]>(`${environment.apiUrl}/analytic/getquiz`).pipe(map(
      val => {
        if (this.dataUtilService.isGoodResponse(val)) {
          return this.dataUtilService.myData(val)
        }
      }
    ))
  }
}
